import React from 'react';
import PropTypes from 'prop-types';
import MenuItems from './MenuItems';
import './LeftMenu.css';
import { Dialog, ListItem } from '@material-ui/core';
import MenuItem from './MenuItem';
import LogoutIcon from '@mui/icons-material/Logout';
import PendingPhotoGate from '../bonus/PendingPhotoGate';
import { pendingPhotoStatus } from '../bonus/pendingPhotos';

class LeftMenu extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      width: '0', // Default width
      open: false,
      photoGateOpen: false,
    };
    this.leftMenuRef = React.createRef();
  }

  componentDidMount() {
    this.calculateWidth();
    window.addEventListener('resize', this.calculateWidth);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.calculateWidth);
  }

  // Logging out is as final as clocking out for a photo still in flight: the
  // upload needs an authenticated session, and logout clears the token. So the
  // photo gate goes first.
  //
  // Asked directly rather than through redux on purpose. This component is the
  // child of a MUI <Slide> in Base.jsx, which takes a ref to measure it, and
  // connect() returns a function component that cannot hold one — connecting
  // this broke the whole shell with a null getBoundingClientRect.
  handleClickOpen = () => {
    pendingPhotoStatus(this.props.user)
      .catch(() => ({ count: 0 }))
      .then(({ count }) => {
        if (count > 0) {
          this.setState({ photoGateOpen: true });
          return;
        }
        this.setState({ open: true });
      });
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  closePhotoGate = () => {
    this.setState({ photoGateOpen: false });
  };

  proceedPastPhotoGate = () => {
    this.setState({ photoGateOpen: false, open: true });
  };

  handleConfirmLogout = () => {
    this.setState({ open: false }, () => {
      this.props.logout();
    });
  };
  calculateWidth = () => {
    if (this.leftMenuRef.current) {
      const newWidth =
        this.leftMenuRef.current.parentElement.offsetWidth +
        this.leftMenuRef.current.offsetWidth -
        this.leftMenuRef.current.clientWidth +
        'px';
      // Update width only if it has changed
      this.setState((prevState) => {
        if (prevState.width !== newWidth) {
          return { width: newWidth };
        }
        return null;
      });
    }
  };

  render() {
    return (
      <div
        className="leftMenu"
        style={{ overflowY: 'hidden', overflowX: 'hidden' }}
      >
        <div
          ref={this.leftMenuRef}
          className="leftMenu"
          style={{
            top: '75px',
            // No paddingBottom here on purpose. The inline 100px that used to
            // sit here was dead scroll runway: it left ~100px of empty rail
            // below the last item (Logout) at the end of the menu. The rule in
            // LeftMenu.css already gives this element a 16px bottom gap.
            width: this.state.width,
            overflowX: 'hidden',
          }}
        >
          <MenuItems
            user={this.props.user}
            routes={this.props.routes}
            userRoutes={this.props.userRoutes}
            isDrawer={this.props.isDrawer}
            closeDrawer={this.props.closeDrawer}
          />
          <PendingPhotoGate
            open={this.state.photoGateOpen}
            actionLabel="Log Out"
            onCancel={this.closePhotoGate}
            onProceed={this.proceedPastPhotoGate}
          />

          <Dialog
            open={this.state.open}
            onClose={this.handleClose}
            aria-labelledby="logout-dialog-title"
            aria-describedby="logout-dialog-desc"
            classes={{ paper: 'logout-dialog-paper' }}
          >
            <div className="logout-dialog">
              <div className="logout-dialog-badge" aria-hidden="true">
                <LogoutIcon />
              </div>

              <h2 className="logout-dialog-title" id="logout-dialog-title">
                Log out?
              </h2>

              <p className="logout-dialog-text" id="logout-dialog-desc">
                You&rsquo;ll be signed out of NuVe System on this device and
                will need to sign in again to continue.
              </p>

              <div className="logout-dialog-buttons">
                <button
                  type="button"
                  className="logout-dialog-btn logout-dialog-btn--ghost"
                  onClick={this.handleClose}
                >
                  Cancel
                </button>

                <button
                  type="button"
                  className="logout-dialog-btn logout-dialog-btn--primary"
                  onClick={this.handleConfirmLogout}
                >
                  Log out
                </button>
              </div>
            </div>
          </Dialog>

          <ListItem
            button
            className="leftMenu-item"
            onClick={this.handleClickOpen}
          >
            <MenuItem
              className="leftMenu-item"
              item={{ label: 'Logout', icon: LogoutIcon }}
            />
          </ListItem>
        </div>
      </div>
    );
  }
}

LeftMenu.propTypes = {
  routes: PropTypes.array,
  userRoutes: PropTypes.array,
  isDrawer: PropTypes.bool,
  closeDrawer: PropTypes.func,
  logout: PropTypes.func,
  user: PropTypes.object,
};

LeftMenu.defaultProps = {
  routes: [],
  userRoutes: [],
  isDrawer: false,
  closeDrawer: () => {},
  logout: () => {},
  user: null,
};

// Deliberately NOT connected — see handleClickOpen. <Slide> in Base.jsx needs a
// ref on this component, and connect() cannot carry one.
export default LeftMenu;
